import React from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { inboxTabOptions } from '~/Classes/conversations'
import DropdownMenu from '~/Common-Objects/UI/DropdownMenu'
import * as styles from './index.module.scss'
import i18n from '~/i18n'
import TierPermissions from '~/Classes/tierPermissions'
import PermissionChecker from '~/Classes/permissions'

export default function InboxDropdownMenu({
    activeInbox,
    inboxes,
    setAddingInbox = () => {},
    changeInbox = () => {},
    userRole = null
}) {
    const history = useHistory()
    const account = useSelector((state) => state.accountMaster)
    const user = useSelector((state) => state.user)
    const permissionStore = useSelector((state) => state.permission)

    return (
        <>
            <DropdownMenu.Root>
                <DropdownMenu.Trigger size='s' className={styles.trigger}>
                    {activeInbox?.name}
                </DropdownMenu.Trigger>

                <DropdownMenu.Portal>
                    <DropdownMenu.Content>
                        <DropdownMenu.Label>
                            {i18n.t('chat:inbox.leftBar.inboxDropdown.inboxes')}
                        </DropdownMenu.Label>

                        <DropdownMenu.RadioGroup value={activeInbox.id}>
                            {inboxes.map((inbox) => {
                                return (
                                    <DropdownMenu.RadioItem
                                        key={'inbox_' + inbox.id}
                                        className={styles.radioItem}
                                        value={inbox.id}
                                        onClick={() => {
                                            changeInbox(inbox.id)
                                        }}
                                    >
                                        <div className={styles.checkboxItemDetail}>
                                            <span className={styles.checkboxItemInboxName}>{inbox.name}</span>
                                            <span className={styles.checkboxItemOpenCount}>
                                                {inbox.openChats} {i18n.t('chat:inbox.leftBar.inboxDropdown.open')}
                                            </span>
                                        </div>
                                    </DropdownMenu.RadioItem>
                                )
                            })}
                        </DropdownMenu.RadioGroup>

                        <DropdownMenu.Separator />
                        {(user.userData.roleId == 1 || userRole == 0) && (
                            <>
                                {PermissionChecker('conversations', permissionStore.permissions, 'write') && (
                                    <>
                                        <DropdownMenu.Item onSelect={setAddingInbox}>
                                            {i18n.t('chat:inbox.leftBar.inboxDropdown.create')}
                                        </DropdownMenu.Item>
                                        <DropdownMenu.Separator />
                                    </>
                                )}

                                <DropdownMenu.Label>
                                    {i18n.t('chat:inbox.leftBar.inboxDropdown.settings')}
                                </DropdownMenu.Label>

                                {inboxTabOptions.map(({ label, value, tierPermission, beta }) => {
                                    if (tierPermission) {
                                        if (!TierPermissions(tierPermission, account).allowed) return null
                                    }
                                    if (beta && !account?.accountMaster?.beta?.[beta]) return null
                                    return (
                                        <DropdownMenu.Item
                                            key={value}
                                            onSelect={(e) => {
                                                // Needed to prevent memory leak as React will try to close the dropdown after it has become unmounted (following route change). See the onSelect tooltip here for more information https://www.radix-ui.com/primitives/docs/components/dropdown-menu#item.
                                                e.preventDefault()
                                                history.push(`/cp/conversations/${activeInbox.id}/${value}`)
                                            }}
                                        >
                                            {i18n.t(label)}
                                        </DropdownMenu.Item>
                                    )
                                })}

                                <DropdownMenu.Separator />
                            </>
                        )}

                        {/* <DropdownMenu.Item
              onClick={() => { history.push(`/cp/conversations/${activeInbox.id}/preferences`, { prevPath: location.pathname }) }}
            >
              User Preferences
            </DropdownMenu.Item> */}

                        {/* <DropdownMenu.Separator /> */}
                        <DropdownMenu.Item
                            onClick={() =>
                                window.open(
                                    'https://transpond.io/support/growing-your-audience/converstations',
                                    '_blank'
                                )
                            }
                        >
                            Help &amp; Support
                        </DropdownMenu.Item>
                    </DropdownMenu.Content>
                </DropdownMenu.Portal>
            </DropdownMenu.Root>
        </>
    )
}
